var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 20V18.6667C20.6666 17.4241 19.8167 16.38 18.6666 16.084M16.3333 8.19384C17.3105 8.58943 17.9999 9.54754 17.9999 10.6667C17.9999 11.7858 17.3105 12.7439 16.3333 13.1395M17.3333 20C17.3333 18.7575 17.3333 18.1362 17.1303 17.6462C16.8596 16.9928 16.3405 16.4736 15.6871 16.203C15.197 16 14.5758 16 13.3333 16H11.3333C10.0907 16 9.46949 16 8.97943 16.203C8.32602 16.4736 7.80689 16.9928 7.53624 17.6462C7.33325 18.1362 7.33325 18.7575 7.33325 20M14.9999 10.6667C14.9999 12.1394 13.806 13.3333 12.3333 13.3333C10.8605 13.3333 9.66659 12.1394 9.66659 10.6667C9.66659 9.19391 10.8605 8 12.3333 8C13.806 8 14.9999 9.19391 14.9999 10.6667Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobLike);
export default __webpack_public_path__ + "static/media/job-like.f8cbbc15ac118b845a2500b2ba8837cc.svg";
export { ForwardRef as ReactComponent };